// Helper singleton
import { removeSyncedMeasurement, setSyncedMeasurement } from './syncedMeasurementsSingleton';

// Constants
import { MEASUREMENT_REMOVE, MEASUREMENT_SET } from './elementMeasurementsConstants';

export const measurementsSet = ({ id, measurements }) => {
    setSyncedMeasurement(id, measurements);
    return { type: MEASUREMENT_SET, id, measurements };
};
export const measurementsRemove = ({ id }) => {
    removeSyncedMeasurement(id);
    return { type: MEASUREMENT_REMOVE, id };
};
